module.exports = __webpack_public_path__ + "static/media/IMG_1776.5f8e5045.jpg";